"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecordDescriptionProperty = exports.recordDescriptionPropertyDefinition = void 0;
exports.recordDescriptionPropertyDefinition = {
    view: { label: 'Record description' },
    constraints: [],
    type: 'rich-text',
    multiple: false,
    name: 'record-description',
};
const isRecordDescriptionProperty = (prop) => {
    return prop.name === exports.recordDescriptionPropertyDefinition.name;
};
exports.isRecordDescriptionProperty = isRecordDescriptionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVjb3JkLWRlc2NyaXB0aW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVjb3JkLWRlc2NyaXB0aW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLG9CQUFvQixFQUFFO0lBQ3JDLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsb0JBQW9CO0NBQ0ssQ0FBQTtBQUkxQixNQUFNLDJCQUEyQixHQUFHLENBQUMsSUFBa0IsRUFBcUMsRUFBRTtJQUNuRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMkNBQW1DLENBQUMsSUFBSSxDQUFBO0FBQy9ELENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9